<h2 mat-dialog-title>
  <mat-icon svgIcon="flag-technical-issue"></mat-icon>
  <div>Flag technical issue</div>
</h2>
<mat-dialog-content>
  <p>
    Flag a technical issue you just experienced, to mark it in our logs for our
    team to reference when troubleshooting.
  </p>
  <mat-form-field class="issue-text">
    <textarea
      matInput
      rows="3"
      placeholder="Describe the issue"
      [(ngModel)]="issueText"
    ></textarea>
  </mat-form-field>
  <h3-debug-log-id></h3-debug-log-id>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">CANCEL</button>
  <button mat-button mat-dialog-close color="primary" (click)="flagIssue()">
    FLAG ISSUE
  </button>
</mat-dialog-actions>
